// extracted by mini-css-extract-plugin
export default {"metadataNote":"la7sNBo7oV470DJVI85K"};